type BuildPaidPlanCheckoutPayloadArgs = {
    workspaceId: string | undefined;
    uid: string | undefined;
    planType: string | undefined;
    funnelSource: string | undefined;
    priceId: string | undefined;
    price: string | number | undefined;
    interval: string | undefined;
    seatAddonQuantity: number;
    successUrl?: string;
    tierCredits?: number;
};

export function buildPaidPlanCheckoutPayload({
    workspaceId,
    uid,
    planType,
    funnelSource,
    priceId,
    price,
    interval,
    seatAddonQuantity,
    successUrl,
    tierCredits
}: BuildPaidPlanCheckoutPayloadArgs) {
    const payload: Record<string, string | number | undefined> = {
        workspace_id: workspaceId,
        uid,
        plan: planType,
        funnel_source: funnelSource,
        priceId,
        price,
        interval,
        seatAddonQuantity
    };

    if (successUrl) {
        payload.success_url = successUrl;
    }

    if (tierCredits != null) {
        payload.tierCredits = tierCredits;
    }

    return payload;
}
